//eslint-disable-next-line no-restricted-imports
import { BreakpointValues } from '@material-ui/core/styles/createBreakpoints';
//eslint-disable-next-line no-restricted-imports
import useTheme from '@material-ui/core/styles/useTheme';
//eslint-disable-next-line no-restricted-imports
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const useCustomMediaQuery = (action: 'up' | 'down', breakpointValue: number | keyof BreakpointValues) => {
  const theme = useTheme();
  const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const breakpointWidth = typeof breakpointValue === 'string' ? theme.breakpoints.values[breakpointValue] : breakpointValue;
  const defaultMatches = action === 'down' ? clientWidth <= breakpointWidth : clientWidth >= breakpointWidth;
  const media = useMediaQuery(theme.breakpoints[action](breakpointWidth), { defaultMatches });
  return media;
};